import { serasaApiRequest } from '../request/serasaApiRequest'

export type RequestResponseTypes = 'safe' | 'unsafe' | 'pay-attention'

const API_ROUTE = '/premium/integrations/v1/verify-url'

export const checkLinkSecurity = async ({
  link,
}: {
  link: string
}): Promise<RequestResponseTypes> => {
  const response = await serasaApiRequest.post(
    API_ROUTE,
    {
      url: link,
    },
    {
      withCredentials: true,
    },
  )
  return response.data.verificationType
}
